import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {AA_MONOMER_LIBRARY_URL} from 'molbio/aa-monomers/AaMonomerConstants';
import * as MonomersDAO from 'molbio/monomers/MonomersDAO';
import * as SidebarConstants from 'sidebar/SidebarConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import SidebarItem from './SidebarItem';

interface MonomerSettingsProps {
  section: SidebarConstants.Section;
}

export default function MonomerSettings({section}: MonomerSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Monomer Settings</div>
      <SidebarItem
        active={section === SidebarConstants.Section.MONOMERS}
        icon={<BenchlingIcon className="result-icon" icon="monomer" />}
        name="Monomer library"
        link={MonomersDAO.MONOMER_LIBRARY_URL}
      />
      {BenchlingConfig.MOLBIO_ENABLE_AA_MONOMER_LIBRARY && (
        <SidebarItem
          active={section === SidebarConstants.Section.AA_MONOMERS}
          icon={<BenchlingIcon className="result-icon" icon="monomer" />}
          name="AA Monomer library"
          link={AA_MONOMER_LIBRARY_URL}
        />
      )}
    </div>
  );
}
